import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router";
import axios from "axios";

import Header from "../../components/header";
import { PuffLoader } from "react-spinners";
import OrderBar from "../../components/orderBar";
import { AuthContext } from "../../context/auth";
import "./style.css";

const Objekat = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isAuthenticated, logout } = useContext(AuthContext);
  const [objekat, setObjekat] = useState();
  const [loading, setLoading] = useState(false);
  const [objekatOrders, setObjekatOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);

  // Set default dates: 30 days ago to now
  const getDefaultStartDate = () => {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    return thirtyDaysAgo.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const getDefaultEndDate = () => {
    return new Date().toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const [startDate, setStartDate] = useState(getDefaultStartDate());
  const [endDate, setEndDate] = useState(getDefaultEndDate());

  useEffect(() => {
    const getObjekat = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/admin/get-objekat-by-id`,
          { id }
        );

        setObjekat(response.data);
      } catch (err) {
        logout();
      } finally {
        setLoading(false);
      }
    };

    getObjekat();
  }, []);

  const getObjekatOrders = async () => {
    if (!objekat) return;

    try {
      setOrdersLoading(true);

      // Convert date strings to ISO strings for the API
      const startDateISO = startDate ? new Date(startDate).toISOString() : null;
      const endDateISO = endDate
        ? new Date(endDate + "T23:59:59").toISOString()
        : null;

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/admin/get-orders-by-objekat`,
        {
          objekatName: objekat.ime,
          startDate: startDateISO,
          endDate: endDateISO,
        }
      );

      setObjekatOrders(response.data);
    } catch (err) {
      logout();
    } finally {
      setOrdersLoading(false);
    }
  };

  useEffect(() => {
    // Initial fetch on mount with default dates (30 days) when objekat is loaded
    if (objekat) {
      getObjekatOrders();
    }
  }, [objekat]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated]);

  return (
    <div className="page-container">
      <Header />
      {loading ? (
        <PuffLoader />
      ) : (
        <div className="page-content">
          <div className="artikli-page-nav">
            <h1 className="page-heading">{objekat?.ime}</h1>
          </div>

          <div className="date-input-container">
            <div className="date-input-wrapper">
              <label className="date-input-label">Od:</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
                className="date-input"
              />
            </div>

            <div className="date-input-wrapper">
              <label className="date-input-label">Do:</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                className="date-input"
              />
            </div>

            <button
              onClick={getObjekatOrders}
              className="date-search-btn"
              disabled={ordersLoading || !objekat}
            >
              {ordersLoading ? "Pretraži..." : "Pretraži"}
            </button>
          </div>

          <div className="blue-line" />

          <div className="home-orders-div">
            {ordersLoading ? (
              <PuffLoader size={50} color={"#031623"} />
            ) : (
              [...(objekatOrders || [])].reverse().map((order, index) => {
                return <OrderBar key={order.id || index} order={order} />;
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Objekat;
